module.exports = __webpack_public_path__ + "static/media/icon-dashboard-deal-pending.d285236c.svg";